import { downloadCSV } from '@helpers/downloadCSV';
import { getAmericanTime } from '@helpers/getAmericanTimezone';
import type { AdminOrganizationsListOrganizationDto } from 'app/API';

const headers = ['ID', 'Name', 'URL', 'Members', 'Workspaces', 'Created'];

type TOrganizationCsvData = Pick<
  AdminOrganizationsListOrganizationDto,
  'id' | 'name' | 'slug' | 'membersCount' | 'workspacesCount' | 'createdAt'
>;

export const downloadOrganizationsCsv = (organizations: TOrganizationCsvData[]) => {
  const array = organizations.map((data) => {
    return {
      id: data.id,
      name: data.name,
      url: data.slug,
      membersCount: data.membersCount ?? 0,
      workspacesCount: data.workspacesCount ?? 0,
      created: getAmericanTime(data.createdAt),
    };
  });
  return downloadCSV(array, headers);
};
